// extracted by mini-css-extract-plugin
export default {"icon":"w_c0"};